import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Mixpanel } from "components/mixpanel/mixpanel";
import { setCollections } from "components/collection/collectionSlice";
import { useSubscription } from "./useSubscription";
import axiosWithToken from "axiosWithToken";
import { themeSetter } from "localFunctions/themeSetter";

const baseURL2 = process.env.REACT_APP_BASEURL2;

export function useUserData() {
  const [userData, setUserData] = useState<any>(null);
  const [credits, setCredits] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { fetchCurrentSubscription } = useSubscription();

  const loadReducedUserFromDB = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axiosWithToken.get(`${baseURL2}api/auth/user`);
      const data = response.data;

      if (!data.error) {
        Mixpanel.identify(data.uid);
        Mixpanel.people.set({
          $name: data.name,
          $email: data.email,
          plan: data.plan,
        });

        setUserData(data);
        const isBiz = data?.isHarbourClub || data?.isBiz4Biz;
        themeSetter(!isBiz);
        localStorage.setItem("user", JSON.stringify(data));
        await loadUserFromDB();

        await fetchCurrentSubscription(false);
      }
    } catch (error) {
      console.error("Error loading reduced user:", error);
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchCurrentSubscription]);

  const loadUserFromDB = useCallback(async () => {
    try {
      setIsLoading(true);

      const collectionsResponse = await axiosWithToken.get(
        `${baseURL2}api/collections`
      );
      dispatch(setCollections(collectionsResponse.data));
    } catch (error) {
      console.error("Error loading account dashboard details:", error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch]);

  return {
    userData,
    setUserData,
    credits,
    setCredits,
    isLoading,
    loadReducedUserFromDB,
    loadUserFromDB,
  };
}
